module.exports = __webpack_public_path__ + "img/full0-min.3936bc50.png";